export default {
    title: "Loyalty Program",
    success_message: "Updated successfully",
    points_reais_relation: "Points - Currency Relation",
    points_reais_relation_subtitle:
        "How much currency does the customer need to spend to earn 1 point?",
    currency: "Currency",
    max_points_per_order: "Maximum points per order",
    max_points_per_order_subtitle:
        "What is the maximum points a customer can earn in a single order? Leave blank for no limit.",
    points: "Points",
    warning_order_value: "Alert threshold value",
    warning_order_value_subtitle:
        "If an order is generated with a value greater than the one informed here, the operator will have to confirm the order before saving.",
    how_to_use_title: "Instructions for use",
    how_to_use_subtitle:
        "Text that appears after the customer generates the coupon explaining how to redeem the benefit.",
    call_to_action_title: "Call to Action: Registration/Review",
    call_to_action_subtitle:
        "Text sent via SMS to the customer when requesting them to complete their registration in Kevi.",
    smart_tags_subtitle:
        "You can use the following smart replacement tags in your content:",
    accents_removed: "*All accents will be removed.",
    rules_title: "Rules",
    rules_subtitle:
        "Text that appears in the customer panel when they click on rules.",
    save_button: "Save",
    page_title: "Kevi | Loyalty Program",
    lifetime_too_short: "The coupon validity time must be at least one day.",
    token_copied: "Token copied successfully!",
    journey: {
        title: "Journey",
        stages: "Stages",
        add_stage_placeholder: "Add stage",
        board_prefix: "Board prefix",
        board_renamed: "Board renamed",
        insert_first_stage: "Insert first stage",
        insert_first_substage: "Insert first substage",
        order_saved: "Order saved",
        stage_renamed: "Stage renamed",
    },
    plugins: {
        title: "Plugins",
        add_sender: "Add sender",
        cost_per_message: "Cost per message",
        credits: "Credits",
        edit_sender: "Edit sender",
        monthly_value: "Monthly value",
        none_registered: "None registered",
        register_sender: "Register sender",
        save_changes: "Save changes",
        send_test_to: "Send test to",
        sender: "Sender",
        sender_saved_test_sent: "Sender saved and test sent",
        soon: "Soon",
    },
    products: {
        title: "Products",
        add_recommendation_optional: "Add recommendation (optional)",
        add_to_group: "Add to group",
        added_products: "Added products",
        ai: "AI",
        ai_placeholder: "AI placeholder",
        ai_recommendation_disclaimer: "AI recommendation disclaimer",
        also_bought: "Also bought",
        batch_edit: "Batch edit",
        bought_in_same_order: "Bought in same order",
        bought_together: "Bought together",
        brand: "Brand",
        clients_who_bought_also_bought: "Clients who bought also bought",
        cost: "Cost",
        current_price: "Current price",
        external_id: "External ID",
        group: "Group",
        group_name: "Group name",
        group_updated: "Group updated",
        groups: "Groups",
        last_10_orders_including_product: "Last 10 orders including product",
        last_purchase: "Last purchase",
        link_removed: "Link removed",
        manage_groups: "Manage groups",
        manual: "Manual",
        manual_recommendation_disclaimer: "Manual recommendation disclaimer",
        new_group: "New group",
        no_images: "No images",
        no_manual_links: "No manual links",
        orders_12m: "Orders 12m",
        price_unit: "Price unit",
        product_linked: "Product linked",
        product_not_found: "Product not found",
        products_updated: "Products updated",
        purchase_history: "Purchase history",
        recommendation_saved: "Recommendation saved",
        remove_from_group: "Remove from group",
        repurchase_days: "Repurchase days",
        revenue_12m: "Revenue 12m",
        search_product_to_link: "Search product to link",
        something_went_wrong: "Something went wrong",
        stock: "Stock",
        use_ai: "Use AI",
    },
    translations: {
        title: "Translations",
        description: "Description",
        error_saving: "Error saving",
        items_for: "Items for",
        key: "Key",
        locale: "Locale",
        no_categories_found: "No categories found",
        no_translations_found: "No translations found",
        original_en: "Original (EN)",
        saved: "Saved",
        saving: "Saving",
        translated: "Translated",
        unable_to_load: "Unable to load",
        unable_to_load_items: "Unable to load items",
    },
    connections: {
        title: "Connections",
        add_page_title: "Add Connections",
        add_new: "Add new connection",
        my_connections: "My connections",
        first_connection_title: "Create your first connection",
        first_connection_description: "Connect with the main platforms",
        channel_placeholder: "Select channel",
        webhook_read_help: "Webhooks are used to receive message read and delivery statuses.",
        coming_soon: "Coming soon",
        request_connection: "Request a connection",
        request_connection_description: "If you need a connection that is not available yet, our team can integrate it for you.",
        request_message_prefix: "Hello, I would like to request a new integration for",
        channels: {
            all: "All connections",
            whatsapp: "WhatsApp",
            sms: "SMS",
            rcs: "RCS",
            email: "Email",
            whatsapp_cloud: "Official WhatsApp",
        },
        table: {
            connector: "Connector",
            name: "Name",
            monthly_value: "Monthly fee",
            cost_per_message: "Cost per send",
            webhook: "Webhook",
            actions: "Actions",
            status: "Status",
            phone_number: "Phone number",
        },
        categories: {
            whatsapp_description: "Integrate with your favorite WhatsApp platform or use Kevi's infrastructure so you do not need to hire anything extra.",
            sms_description: "Integrate with your favorite SMS platform or use Kevi's infrastructure so you do not need to hire anything extra.",
            rcs_description: "Send RCS with text, image, card, carousel, or file through Comtele.",
            email_description: "Integrate with your favorite email platform or use Kevi's infrastructure so you do not need to hire anything extra.",
            whatsapp_cloud_description: "Integrate with your Official WhatsApp customer service platform.",
        },
        common: {
            set_default: "Set as default",
            copied_url: "Copy URL",
            not_supported: "Not supported",
            active: "Active",
            unavailable: "Unavailable",
            not_configured: "Not configured",
            error: "Error",
            unknown: "Unknown",
            loading: "Loading...",
            connected: "Connected",
            disconnected: "Disconnected",
            corrupted_instance: "Corrupted instance.",
            corrupted_instance_tooltip: "This WhatsApp instance is corrupted and must be replaced or reconfigured.",
            webhook_pending_tooltip: "The webhook has not been configured yet. Configure it to track whether messages were read and delivered.",
            webhook_error_tooltip: "There was an error configuring the webhook. Please review the settings.",
            webhook_unknown_tooltip: "Webhook status could not be determined through the integration. Please check with your provider.",
            webhook_unavailable_tooltip: "This integration does not support webhooks.",
            sender_no_webhooks: "This sender does not support webhooks",
            click_view_webhooks: "Click to view webhook events",
            last_event_received: "Last event received at {$0}",
            credits_suffix: "credits",
            copied_success: "URL copied successfully!",
            copy_error: "Error copying URL",
            not_available: "N/A",
        },
        sender_form: {
            details_tab: "Details",
            settings_tab: "Configuration",
            adding_connection: "Adding connection",
            connection_cost: "Connection cost",
            monthly_subscription: "Monthly subscription",
            connection_valid_per_phone: "Connection valid per phone number",
            credit_cost: "Credit cost",
            per_message_sent: "Per message sent",
            what_you_need_to_know: "What you need to know",
            edit: "Edit",
            close: "Close",
            install_connection: "Install connection",
            edit_settings: "Edit settings",
            configure_how: "How to configure",
            edit_instructions: "Edit instructions",
            edit_sender_description: "Edit sender description",
            edit_configuration_instructions: "Edit configuration instructions",
            format_help: "Use the formatting toolbar to style the text.",
            description_placeholder: "Enter the sender description...",
            instructions_placeholder: "Enter the configuration instructions...",
            cancel: "Cancel",
            save: "Save",
            default_body: "<p>Information about this connection will be displayed here.</p>",
            default_instructions: "<p>If you need help, contact Kevi support through WhatsApp.</p>",
        },
        steps: {
            configure: "Configure",
            scan: "Scan",
            test: "Test",
            finish: "Finish",
            title: "Title",
            cancel: "Cancel",
            next: "Next",
            saving: "Saving...",
            back: "Back",
            send_test: "Send test",
            sending_test: "Sending test...",
            enter_email: "Enter an email",
            example_email: "example@email.com",
            enter_mobile_number: "Enter a mobile number",
            enter_mobile_short: "Enter a mobile number",
            select_template: "Select template",
            no_template_available: "No template available.",
            header: "Header",
            body: "Body",
            button: "Button",
            image_url: "Image URL",
            header_media_url_video: "Video URL",
            header_media_url_document: "Document URL",
            header_media_url_gif: "GIF URL",
            document_filename: "File name (optional)",
            document_filename_placeholder: "e.g. invoice.pdf",
            location_header: "Location (header)",
            location_latitude: "Latitude",
            location_longitude: "Longitude",
            location_name: "Location name",
            location_address: "Address",
            approved: "Approved",
            rejected: "Rejected",
            pending: "Pending",
            test_completed_success: "Test completed successfully",
            did_not_receive_test: "I did not receive the test.",
            done: "Finish",
            channel_ready_default: "Your connection is active and ready to use.",
            channel_ready_whatsapp: "Your WhatsApp connection is active and ready to use.",
            channel_ready_sms: "Your SMS connection is active and ready to use.",
            channel_ready_rcs: "Your RCS connection is active and ready to use.",
            channel_ready_email: "Your email connection is active and ready to use.",
            channel_ready_whatsapp_cloud: "Your WhatsApp Cloud connection is active and ready to use.",
            connection_check_error: "Error checking the connection.",
            verify_settings_or_support: "Check the settings or contact support.",
            scan_qr_instruction: "Open WhatsApp and scan the QR code",
            qr_code_error: "Error generating the QR code.",
            whatsapp_connected: "WhatsApp connected",
            generate_qr_again: "Generate QR code again",
            try_again: "Try again",
            expand_qr: "Expand QR Code",
            expanded_qr_title: "Scan QR Code",
            keep_phone_close: "Point your phone's camera at the screen to connect.",
            close: "Close",
        },
        webhooks: {
            title: "Webhooks",
            back: "Back",
            status_24h_summary: "Status calculated from events received in the last 24h.",
            last_event: "Last event: {$0}",
            description_line_1: "<strong>Webhooks</strong> are notifications sent by your provider (Mailgun, SMS, WhatsApp Cloud, etc.) to Kevi when an event happens (delivery, read, failure, reply).",
            description_line_2: "They are important so Kevi can update statuses, metrics, and automations reliably.",
            managed_by_kevi: "This sender is managed by Kevi, so the webhook URL is configured automatically.",
            webhook_url: "Webhook URL",
            copy: "Copy",
            received_events: "Received events",
            no_events: "No webhook events have been received for this sender yet.",
            received_at: "Received at",
            event: "Event",
            contact: "Contact",
            client: "Client",
            provider_id: "Provider ID",
            status: "Status",
            error: "Error",
            data: "Data",
            processed: "Processed",
            failed: "Failed",
            view_data: "View data",
            details_title: "Webhook data",
            summary: "Summary",
            received: "Received",
            provider_event: "Provider event",
            payload_json: "Payload (JSON)",
            headers_json: "Headers (JSON)",
            close: "Close",
        },
        notifications: {
            load_error: "Error loading connections: {$0}",
            execute_command_error: "Error executing command: {$0}",
            set_default_success: "Connection set as default successfully",
            set_default_error: "Error setting default connection: {$0}",
            sender_id_not_found: "Error: sender ID not found. Save the configuration first.",
            test_sent_success: "Test sent successfully",
            config_saved_success: "Configuration saved successfully",
            description_saved_success: "Description saved successfully",
            description_save_error: "Error saving description: {$0}",
            instructions_saved_success: "Instructions saved successfully",
            instructions_save_error: "Error saving instructions: {$0}",
            unknown_error: "Unknown error",
            command_executed_success: "Command executed successfully",
            test_send_error: "Error sending test: {$0}",
            price_updated_success: "Monthly value updated successfully",
            price_update_error: "Error updating monthly value",
            credits_cost_updated_success: "Cost per message updated successfully",
            credits_cost_update_error: "Error updating cost per message",
            sender_default_has_others: "Default sender for {$0}. Set another default before deleting.",
            sender_in_use_automations: "In use by automation(s): {$1}. Update or deactivate before deleting.",
            sender_in_use_branches: "Linked to branch(es): {$0}. Unlink before deleting.",
            sender_in_use_users: "Linked to user(s): {$0}. Unlink before deleting.",
            sender_not_found: "Sender not found or inactive.",
        },
    },
};
